"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _dealerDetails = _interopRequireDefault(require("../styles/dealerDetails.css"));
var _types = _interopRequireDefault(require("./types"));
var Directions = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(Directions, _React$Component);
  function Directions(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.openDirections = _this.openDirections.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = Directions.prototype;
  _proto.openDirections = function openDirections(eventType) {
    var self = this;
    return function (event) {
      if (eventType === 'key' && event.keyCode !== 13 /* enter */) {
        return;
      }
      var address = self.props.address;
      var origin = ''; // setting the origin to be blank so google can set it to the users location reliably
      var destination = address.latitude + "," + address.longitude;
      if (typeof window !== 'undefined') {
        window.open("https://www.google.com/maps/dir/?api=1&origin=" + origin + "&destination=" + destination, '_blank');
      }
    };
  };
  _proto.render = function render() {
    var _this$props = this.props,
      theme = _this$props.theme,
      getDirectionsLabel = _this$props.getDirectionsLabel;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
      _react["default"].createElement("a", {
        onClick: this.openDirections('mouse'),
        onKeyDown: this.openDirections('key'),
        className: _dealerDetails["default"].goToDealerAddress + " " + theme.textLinkPrimary,
        role: "link",
        tabIndex: "0"
      }, getDirectionsLabel)
    );
  };
  return Directions;
}(_react["default"].Component);
exports["default"] = Directions;